<template>
    <div class="ah-card-header" v-if="isMaterial">
        <img class="ah-card-header-image"
             :src="image.src + '?width=256'"
             :alt="heading" />
        <species-icons :species="species" />
    </div>
  <div class="ah-card-header" v-else>
      <a :href="links[0].href">
          <img class="ah-card-header-image"
               :src="image.src + '?width=256'"
               :alt="heading" />
          <species-icons :species="species" />
      </a>
  </div>
</template>

<script>
  import SpeciesIcons from './SpeciesIcons.vue'

  export default {
    name: 'card-header',
    props: {
      image: {
        type: Object,
        default: function() {
          return {
            src: 'https://via.placeholder.com/240x165?text=Product+Image',
            description: 'Product Image Placeholder',            
          }
        }
      },
      species: Array,
      heading: {
        type: String,
        default: 'Card Heading',
        },
      links: Array,
      isMaterial: Boolean
    },
    components: {
      SpeciesIcons,
    },
  }
</script>

<style scoped>
  .ah-card-header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 200px;
  }

  .ah-card-header a {
      display: flex;
      height: 100%;
      width: 100%;
      align-items: flex-end;
      justify-content: center;
  }

  .ah-card-header-image {
    max-height: calc(100% - 16px);
  }
</style>
